import { FC } from 'react';
import styled from 'styled-components';
import { ISelectOptionProps, ISelectGroupProps } from 'components/form/types';
import { useTranslation } from 'react-i18next';
import ActionControl from './ActionControl';

interface IProps {
  methods: any;
  title?: string;
  name: string;
  options: ISelectGroupProps[];
  selected: ISelectOptionProps[];
  maxPositionsAvailable: number;
  updateData: (data: any) => void;
  hasPermission?: boolean;
}
const ActionCell: FC<IProps> = ({
  methods,
  title,
  name,
  options,
  selected,
  maxPositionsAvailable,
  updateData,
  hasPermission,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {title && <h3 className="h6 mb-2">{title}</h3>}
      {selected.map((select, index) => (
        <ActionControl
          key={index + 1}
          id={index + 1}
          name={`${name}-${index + 1}`}
          options={options}
          selected={selected}
          hasPermission={hasPermission}
          removeItem={(id: any) => {
            // Get all the values currently selected before delete
            const values = selected.map((opt, i) => {
              // Clear fields errors
              methods.clearErrors(`${name}-${i + 1}`);

              return methods.getValues(`${name}-${i + 1}`);
            });

            // Filter the values that should be kept after delete
            const updatedValues = values.filter((opt, i) => i + 1 !== id);

            // Set the form values to match newly filtered values
            updatedValues.forEach((val, i) => methods.setValue(`${name}-${i + 1}`, val));

            // After deleting one value, unregister the last previously selected form value
            // to prevent field validation on form submit
            methods.unregister(`${name}-${values.length}`);

            // Update positions
            updateData(updatedValues);
          }}
          updateData={selectedOpts => {
            // Get values set in form state
            const updatedSelected = selectedOpts.map((opt: any, i: number) => methods.getValues(`${name}-${i + 1}`));
            updateData(updatedSelected);
          }}
          position={index}
          methods={methods}
        />
      ))}
      {maxPositionsAvailable > selected.length && (
        <AddPositionBtn
          className={!hasPermission ? 'u-disabled' : ''}
          onClick={() => {
            if (hasPermission) updateData([...selected, null]);
          }}
        >
          {t('common.addPosition')}
        </AddPositionBtn>
      )}
    </>
  );
};

export default ActionCell;

const AddPositionBtn = styled.span`
  color: ${props => props.theme.colors.violet};
  padding: 1rem;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &.u-disabled {
    opacity: 0.5;
    cursor: default;

    &:hover {
      text-decoration: none;
    }
  }

  @media ${props => props.theme.breakpoints.sm} {
    padding: 0.25rem;
  }
`;
